<template>
  <div class="container">
    <transition name="fade">
      <div v-if="rewidgvis" class="">
        <rewidg />
      </div>
    </transition>

    <transition name="fade">
      <b-container v-if="vandmvis" class="formback col-lg-5 col-md-6 col-sm-8 element-center">
        <div>
          <h3 v-if="qualifyAlert" id="alert">
            Sorry, the details you entered doesn't qualify for a repair payment plan
          </h3>
        </div>

        <b-row class="col-12 mt-3">
          <div class="col-8 mx-auto">
            <div v-if="!apiError">
              <select v-model="model.year" class="form-control" @change="yearChanged()">
                <option value="">Year</option>
                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
              </select>
            </div>
            <div v-else>
              <input v-model="model.year" class="form-control" placeholder="Type Year Here" />
            </div>

            <div v-if="!apiError">
              <select
                v-model="model.make"
                class="form-control"
                :disabled="!makes.length"
                @change="makeChanged()"
              >
                <option value="">Make</option>
                <option v-for="make in makes" :key="make" :value="make">{{ make }}</option>
              </select>
            </div>
            <div v-else>
              <input v-model="model.make" class="form-control" placeholder="Type Make Here" />
            </div>
            <div v-if="!apiError">
              <select
                v-model="model.model"
                class="form-control"
                :disabled="!models.length"
                @change="modelChanged()"
              >
                <option value="">Model</option>
                <option v-for="item in models" :key="item.name" :value="item.name">{{
                  item.name
                }}</option>
              </select>
            </div>
            <div v-else>
              <input v-model="model.model" class="form-control" placeholder="Type Model Here" />
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="col-12">
            <input
              v-model="odometer"
              type="number"
              :style="computedInputStyleEnable"
              class="form-control odo"
              placeholder="Odometer in KM"
              :disabled="loading"
            />
          </div>
          <b-row v-show="odoerrview" class="mt-2 mx-auto">
            <b-col>
              <b-alert show variant="danger">Sorry, the mileage is too high :(</b-alert>
            </b-col>
          </b-row>
        </b-row>

        <button
          :disabled="(!vin && !model.model) || !odometer || loading"
          class="btn btn-success mb-5 nextButton"
          @click="submit"
        >
          Next
        </button>
        <b-row v-show="loading" align-h="center" class="mt-3">
          <b-col cols="6">
            <!-- <Loading
            v-if="loading"
            color="purple"
          /> -->
            <div class="spinner-border text-success" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </b-col>
        </b-row>

        <div class="error hide">
          <div class="d-flex justify-content-center mt-2">
            <span style="color: red">Vehicle not found, please call</span>
          </div>
          <div class="d-flex justify-content-center">
            <a class="tel" href="tel:+1-604-245-6680">(604) 245-6680</a>.
          </div>
        </div>
      </b-container>
    </transition>
    <transition name="fade">
      <div
        v-if="visible"
        class="vue-back-to-top"
        :style="`bottom:${this.bottom};left:${this.left};`"
      >
        <Main />
      </div>
    </transition>
  </div>
</template>

<script>
import $ from 'jquery'
import Loading from '../components/loading'

export default {
  name: 'VandM',
  components: {
    Loading,
  },
  props: {
    message: Boolean,
  },
  data() {
    return {
      apiError: false, // Add this property to track API errors
      qualifyAlert: false,
      step: 1,
      vandmvis: true,
      visible: false,
      rewidgvis: false,
      buttonShow: true,
      makes: [],
      models: [],
      trims: [],
      vin: '',
      odometer: null,
      odoerror: false,
      verror: false,
      styleObjectGreen: {
        border: '2px solid green',
        // backgroundColor: 'lightgreen'
      },
      styleOBjectRed: {
        border: '2px solid red',
        // backgroundColor: 'pink'
      },
      model: {
        year: '',
        make: '',
        model: '',
        trim: '',
      },
      years: [
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024,
        2025,
        2026,
      ],
      loading: false,
      odoerrview: false,
    }
  },
  computed: {
    computedInputStyleEnable() {
      // or use one method instead of computed property
      // apply your own logic at here to determinate if enable input-has-value-style
      return this.odometer && this.odometer.length > 0 ? this.styleObjectGreen : this.styleOBjectRed
    },
  },
  watch: {
    message: function() {
      if (true) {
        this.$nextTick(function() {
          this.$refs.vininput.focus()
        })
      }
    },
  },
  mounted() {
    $('.navbar').addClass('darkHeader'), this.$refs.ymminput.focus()
  },
  methods: {
    odometerreading() {
      if (this.odometer > 200000) {
        this.odoerror = true
        return (this.buttonShow = false)
      } else this.odoerror = false
      return (this.buttonShow = true)
    },
    closeWin() {
      return [(this.vandmvis = false), (this.visible = true)]
    },
    // closeApp() {
    //   if ('parentIFrame' in window) window.parentIFrame.close();
    //   return false;
    // },
    yearChanged() {
      const { year } = this.model
      this.model = {
        year,
        make: '',
        model: '',
        trim: '',
      }
      this.makes = []
      this.models = []
      this.trims = []
      if (!year) return
      this.axios
        .get(`${process.env.ROOT_API}/vehicle/search/makes?year=${year}`)
        .then(({ data }) => {
          const { makes } = data
          this.makes = makes
        })
        .catch(() => {
          this.apiError = true // Set apiError to true if there's an error
        })
    },
    makeChanged() {
      const { year, make } = this.model
      this.model = {
        year,
        make,
        model: '',
        trim: '',
      }
      this.models = []
      this.trims = []
      if (!make) return
      this.axios
        .get(`${process.env.ROOT_API}/vehicle/search/models?year=${year}&make=${make}`)
        .then(({ data }) => {
          const { models } = data
          this.models = models
        })
        .catch(() => {
          this.apiError = true
        })
    },
    modelChanged() {
      const { year, make, model } = this.model
      this.model = {
        year,
        make,
        model,
        trim: '',
      }
      this.trims = []
      if (!model) return

      const fetchTrims = new Promise((resolve, reject) => {
        this.axios
          .get(
            `${process.env.ROOT_API}/vehicle/search/trims?year=${year}&make=${make}&model=${model}`
          )
          .then(({ data }) => {
            const { trims } = data
            resolve(trims)
          })
          .catch(() => {
            reject(new Error('API error'))
          })
      })

      const timeout = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Request timed out')), 20000)
      )

      Promise.race([fetchTrims, timeout])
        .then(trims => {
          this.trims = trims !== null ? trims : 'Trim'
        })
        .catch(error => {
          this.apiError = true
          console.error(error.message)
        })
    },

    closereseize() {
      if ('parentIFrame' in window) window.parentIFrame.size(70)
      return false
    },
    widgresize() {
      if ('parentIFrame' in window) window.parentIFrame.size(340)
      return false
    },
    submit() {
      $('.error').addClass('hide')
      if (this.apiError) {
        const { year, make, model } = this.model
        console.log('loaded more than 17')
        this.odometer = 1000
        this.$store.state.userData.marketValue = 30000
        this.$store.state.userData.carDetails = year.toString().concat(' ', make, ' ', model)
        this.approvedLoan = 10000
        this.$store.state.userData.approvedLoanAmount = this.approvedLoan
        this.vandmvis = false
        this.rewidgvis = true
        this.$store.state.userData.step = 2
        this.widgresize()
      }
      if ((this.vin.length !== 17 && !this.model.model) || !this.odometer || this.loading) {
        return
      }
      if (this.odometer > 300000) {
        this.odoerrview = true
      } else {
        this.loading = true
        this.qualifyAlert = false
        this.$store.state.userData.vin = this.vin
        this.$store.state.userData.odometerReading = this.odometer
        const odometer = Math.round(this.odometer * 0.62)
        const { year, make, model, trim } = this.model
        this.$store.state.userData.year = year
        this.$store.state.userData.make = make
        this.$store.state.userData.model = model
        this.$store.state.userData.trim = trim
        if (year < 2017) {
          console.log('loaded less than 17')
          const url = this.vin
            ? `${process.env.ROOT_API}/vehicle/value?mileage=${odometer}&vin=${this.vin}`
            : `${process.env.ROOT_API}/vehicle/value?mileage=${odometer}&year=${year}&make=${make}&model=${model}&trim=${trim}`
          this.axios
            .get(url)
            .then(response => {
              const {
                mean,
                success,
                car_details: carDetails,
                certainty,
                max_loan_amount,
                low,
                high,
              } = response.data
              if (!success) {
                throw new Error('An error occurred')
              }
              const certaintyScore = certainty <= 1 ? Math.round(certainty * 100) : certainty

              // ✅ store market value + details from API
              this.$store.state.userData.marketValue = mean
              this.$store.state.userData.carDetails = carDetails

              // ✅ use server-approved amount (fallback if missing)
              this.approvedLoan = typeof max_loan_amount === 'number' ? max_loan_amount : 0
              this.$store.state.userData.max_loan_amount =
                typeof max_loan_amount === 'number' ? max_loan_amount : 0

              // ✅ apply min/max caps once
              this.$store.state.userData.approvedLoanAmount = Math.min(
                Math.max(this.approvedLoan, 1500),
                10000
              )
              this.approvedLoan = this.$store.state.userData.max_loan_amount

              // (optional) keep low/high for later UI if you want
              this.$store.state.userData.marketValueLow = low
              this.$store.state.userData.marketValueHigh = high

              if (
                carDetails.substring(0, 4) > 2006 &&
                odometer < 250000 &&
                certaintyScore > 40 &&
                this.approvedLoan > 500
              ) {
                this.odometer = odometer
                this.vandmvis = false
                this.rewidgvis = true
                this.$store.state.userData.step = 2
                this.widgresize()
              } else {
                this.loading = false
                this.vin = ''
                this.model = { year: '', make: '', model: '', trim: '' }
                this.odometer = null
                return [(this.verror = true), (this.buttonShow = false)]
              }
            })
            .catch(error => {
              console.log('loaded less than 17')
              this.odometer = 10000
              this.$store.state.userData.marketValue = 30000
              this.$store.state.userData.carDetails = year.toString().concat(' ', make, ' ', model)
              this.approvedLoan = 10000
              this.$store.state.userData.max_loan_amount = 1500
              this.$store.state.userData.approvedLoanAmount = this.approvedLoan
              this.vandmvis = false
              this.rewidgvis = true
              this.$store.state.userData.step = 2
              this.widgresize()
            })
        } else {
          console.log('loaded more than 17')
          console.log('vehicle ', year, make, model)
          this.odometer = 10000
          this.$store.state.userData.marketValue = 30000
          this.$store.state.userData.carDetails = year.toString().concat(' ', make, ' ', model)
          this.approvedLoan = 10000
          this.$store.state.userData.approvedLoanAmount = this.approvedLoan
          this.vandmvis = false
          this.rewidgvis = true
          this.$store.state.userData.step = 2
          this.widgresize()
        }
      }
    },
  },
}
</script>

<style scoped>
.titlecol {
  color: darkgrey;
}
.vue-back-to-top {
  z-index: 1000;
  cursor: pointer;
  position: fixed;
  width: 340px;
}

.lds-roller {
  position: absolute !important;
  display: inline !important;
  right: 120px;
}

.formback {
  background-color: white;
  border-radius: 10px;
}

.error {
  padding: 15px 0;
  color: red;
}

.errorwidth {
  width: 340px;
}

.error.hide {
  display: none;
}

.flow-title {
  padding-top: 2%;
}

.element-margin {
  text-align: center;
}
.nextButton {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin-top: 7px;
}

.container {
  padding-left: 0px;
  padding-right: 0px;
}

.closeButton:hover {
  background-color: red;
}

.box {
  border-top: 3px solid #40c991;
  padding-bottom: 1px;
  max-width: 340px;
}

.box .separator .line {
  width: 1px;
  height: 10%;
  background-color: #a803a8;
  margin: 0 auto;
}

.box .separator .or {
  width: fit-content;
  display: flex;
  align-items: center;
}

.vue-back-to-top {
  left: 0px;
}

.nextButton {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 18px;
}

.tel:hover {
  color: green;
}

select,
input {
  margin-top: 1.5rem;
  border-radius: 1rem;
}

input.vin {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
}

select:focus,
input:focus {
  box-shadow: none;
}

input.odo {
  width: 250px;
  max-width: 250px;
  margin: 20px auto 0 auto;
}

.odo select {
  width: 70px;
}

#alert {
  color: red;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.ele div.x {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  display: inline;
  float: right;
}

.ele div.x.slow {
  -webkit-transition-duration: 1s;
  transition-duration: 1s;
}

ul {
  list-style: none;
  float: right;
  display: block;
  width: 100%;
}

li {
  display: inline;
  width: 25%;
  float: right;
}

.ele {
  width: 25%;
  display: inline;
}

.x {
  float: left;
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #ccc;
  border-radius: 2px;
  border: solid 2px #fff;
  transition: all 0.3s ease-out;
  cursor: pointer;
}

.x.large {
  width: 33px;
  height: 33px;
}

.x.medium {
  width: 20px;
  height: 20px;
}

.x.small {
  width: 10px;
  height: 10px;
}

.x.switch {
  width: 15px;
  height: 15px;
}

.x.grow {
}

.x.spin:hover {
  background: #40c991;
  transform: rotate(180deg);
}

.x.flop:hover {
  background: #40c991;
  transform: rotate(90deg);
}

.x.t:hover {
  background: #40c991;
  transform: rotate(45deg);
}

.x.shift:hover {
  background: #40c991;
}

.x b {
  display: block;
  position: absolute;
  height: 0;
  width: 0;
  padding: 0;
  margin: 0;
}

.x.small b {
  border: solid 5px rgba(255, 255, 255, 0);
}

.x.medium b {
  border: solid 10px rgba(255, 255, 255, 0);
}

.x.large b {
  border: solid 15px rgba(255, 255, 255, 0);
}

.x.switch b {
  border: solid 10px rgba(255, 255, 255, 0);
}

.x b:nth-child(1) {
  border-top-color: #fff;
  top: -2px;
}

.x b:nth-child(2) {
  border-left-color: #fff;
  left: -2px;
}

.x b:nth-child(3) {
  border-bottom-color: #fff;
  bottom: -2px;
}

.x b:nth-child(4) {
  border-right-color: #fff;
  right: -2px;
}

.checkmark {
  display: block;
  margin: 0 auto;
  text-align: center;
}

.checkmark:after {
  content: '';
  display: block;
  border: solid #000;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkmark.large:after {
  width: 12px;
  height: 24px;
}

.checkmark.medium:after {
  width: 8px;
  height: 16px;
}

.checkmark.small:after {
  width: 4px;
  height: 8px;
}

.checkmark.tiny:after {
  width: 1px;
  height: 2px;
  border-width: 0 1px 1px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/vandm.vue